<template>
  <section>
    <m-assembly-table
      :formData='formData'
      :columns='columns'
      :data='data'
      :total='total'
      :currentPage='currentPage'
      :pageSize='pageSize'
      :settings='settings'
      :tableButtons='tableButtons'
      :loading='loading'
      @onSubmit='onSubmit'
      @onPageSizeChange='onPageSizeChange'
      @onCurrentPageChange='onCurrentPageChange'
      @onEdit='onEdit'
      @onDelete='onDelete'
    ></m-assembly-table>
  </section>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index';

export default {
    components: { mAssemblyTable },
    data() {
        return {
            isPoll: false,
            gender: '',
            loading: false,
            formData: {
                row: 2,
                items: [
                    {
                        value: '',
                        field: 'type',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            multiple: false,
                            values: [
                                {
                                    label: '海外弹窗公告',
                                    value: '海外弹窗公告',
                                },
                            ],
                        },
                        type: 'select',
                        title: '公告类型',
                    },
                    {
                        value: '',
                        field: 'title',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: '公告标题',
                    },
                    {
                        value: '',
                        field: 'status',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            multiple: false,
                            values: [
                                { value: '0', label: '已发布' },
                                { value: '1', label: '未发布' },
                            ],
                        },
                        type: 'select',
                        title: '发布状态',
                    },
                    {
                        value: [],
                        field: 'date',
                        type: 'datePicker',
                        title: '日期',
                        placeholder: '选择日期',
                        layout: {
                            row: 2,
                            span: 8,
                            offset: 0,
                        },
                        options: {
                            type: 'daterange',
                            format: 'yyyy/MM/dd',
                        },
                        style: 'width: 100%',
                    },
                ],
                buttons: {
                    submitText: '查询',
                    resetText: '清空',
                },
            },
            columns: {
                showCheckbox: false,
                columns: [
                    {
                        title: '公告类型',
                        key: 'type',
                        align: 'center',
                    },
                    {
                        title: '公告标题',
                        key: 'title',
                        align: 'left',
                        render: (h, params) => {
                            const { isTop, title } = params.row;
                            return h('div', isTop === '0' ? `【置顶】${title}` : title);
                        },
                    },
                    {
                        title: '是否发布',
                        align: 'center',
                        render: (h, params) => {
                            return h('span', params.row.status === '0' ? '是' : '否');
                        },
                    },
                    {
                        title: '创建时间',
                        align: 'center',
                        render: (h, params) => {
                            return h('span', moment(params.row.creationDate).format('YYYY-MM-DD'));
                        },
                    },
                    {
                        title: '最后更新人',
                        key: 'updateUser',
                        align: 'center',
                    },
                ],
                buttons: {
                    edit: { icon: true, label: true, type: 'primary' },
                    delete: { icon: true, label: true },
                    columnWidth: 200,
                },
            },
            tableButtons: {
                systemButtons: [{ name: 'btn_add', label: '新增', url: '/announcement/announcementAdd' }],
            },
            data: [],
            pageSize: 10,
            currentPage: 1,
            total: 0,
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 30, 50, 80],
                needSearch: true,
                needValidation: true,
            },
            tableTitle: '平台公告',
        };
    },
    methods: {
        onSubmit() {
            this.getData();
        },
        // 页容量改变时触发
        onPageSizeChange(current, pageSize) {
            this.pageSize = pageSize;
            this.getData();
        },
        // 当前页改变时触发
        onCurrentPageChange(current) {
            this.currentPage = current;
            this.getData();
        },
        onEdit(row) {
            this.$router.push({ name: 'announcementEdit', query: { id: row.id } });
        },
        onDelete({ id }) {
            this.$Modal.confirm({
                title: '删除确认',
                content: '确认要删除吗？',
                onOk: () => {
                    axios.get('/gscint/advertise/delete', {
                        params: {
                            id,
                        },
                    }).then((resp) => {
                        const { code, msg } = resp.data.data;
                        if (code === '0') {
                            this.$Message.success('删除成功！');
                            this.getData();
                        } else {
                            this.$Message.error(msg);
                        }
                    });
                },
            });
        },
        getData() {
            this.loading = true;
            const params = {
                ...this.getFormDataVModel(this.formData.items),
                pageSize: this.pageSize,
                pageNum: this.currentPage,
            };
            if (this.formData.items[3].value.length > 0 && this.formData.items[3].value[0] !== '') {
                params.startTime = this.formData.items[3].value[0].replace(/\//g, '-');
            }
            if (this.formData.items[3].value.length > 0 && this.formData.items[3].value[1] !== '') {
                params.endTime = this.formData.items[3].value[1].replace(/\//g, '-');
            }
            axios.post('/gscint/advertise/selectList', params).then((resp) => {
                this.loading = false;
                const { success, data, msg } = resp.data;
                if (success) {
                    this.data = data.list;
                    this.total = data.total;
                } else {
                    this.$Modal.error({
                        content: msg,
                    });
                }
            });
        },
    },
    mounted() {
        this.getData();
    },
};
</script>
